import { SmileOutlined } from '@ant-design/icons'
import { Popover } from 'antd'
import Picker from 'emoji-picker-react'
import React from 'react'

export interface EmojiPickerProps {
  onClick: (emoji: string) => void
}

export const EmojiPicker: React.FC<EmojiPickerProps> = ({ onClick, ...props }) => {
  const emojiPicker = <Picker disableAutoFocus onEmojiClick={(_event, o) => onClick(o.emoji)} />

  return (
    <Popover {...props} content={emojiPicker} trigger={['click']}>
      <SmileOutlined />
    </Popover>
  )
}
